var _ACTION_HANDLERS;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import request from "superagent";
import { instanceUrl, site } from "../utils/cms"; // ------------------------------------
// Constants
// ------------------------------------

export var NAV_LOADING = "NAV_LOADING";
export var NAV_LOADED = "NAV_LOADED"; // ------------------------------------
// Actions
// ------------------------------------

export function loadNav() {
  return function (dispatch) {
    dispatch({
      type: "NAV_LOADING",
      payload: true
    });
    request.post(instanceUrl() + "WebServices/cms/Page.asmx/GetMenu").send({
      site: site()
    }).set("Accept", "application/json").set("Content-Type", "application/json").end(function (err, response) {
      if (err || !response.ok) {
        dispatch({
          type: "NAV_LOADED",
          payload: {
            nav: [],
            navLoading: false
          }
        });
        return;
      }

      response = response.body.d;
      dispatch({
        type: "NAV_LOADED",
        payload: {
          nav: response.records,
          navLoading: false
        }
      });
    });
  };
}
export var actions = {
  loadNav: loadNav
}; // ------------------------------------
// Action Handler
// ------------------------------------

var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _ACTION_HANDLERS[NAV_LOADING] = function (state, action) {
  return _extends({}, state, {
    navLoading: action.payload
  });
}, _ACTION_HANDLERS[NAV_LOADED] = function (state, action) {
  return _extends({}, state, {
    navLoading: action.payload.navLoading,
    nav: action.payload.nav
  });
}, _ACTION_HANDLERS); // ------------------------------------
// Reducer
// ------------------------------------

var initialState = {
  navLoading: false,
  nav: []
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}